'use strict';
import angular from 'angular';
import snapchatPixelHtmlUrl from './views/snapchatPixelsList.html';
var app = angular.module('app.snapchatPixelControls.component', []);
app.component('snapchatPixelControls', {
    bindings: {
        showActions: '<',
        selectedSnapchatPixel: '=',
        clusterId: '=',
        isFormEdit: '=',
        clientId: '='
    },
    templateUrl: snapchatPixelHtmlUrl,
    controller: function (FormService) {
        var self = this;
        self.selectedPixel = '';
        self.snapchatPixelsList = [];
        self.togglePixelsList = function () {
            self.showActions = !self.showActions;
        };
        self.getSnapchatPixel = function () {
            FormService.getSnapchatPixels(self.clientId).then(function (success) {
                if (success && success.data && success.data.length > 0) {
                    self.snapchatPixelsList = success.data.map(function (pixel) {
                        return {
                            id: pixel.id,
                            name: pixel.name
                        };
                    });

                    // Set the selected name in edit mode
                    if (Array.isArray(self.selectedSnapchatPixel) && self.selectedSnapchatPixel.length > 0) {
                        const existingId = self.selectedSnapchatPixel[0].id;
                        const match = _.find(self.snapchatPixelsList, { id: existingId });
                        if (match) {
                            self.selectedPixel = match.name;
                        }
                    }
                }
            }, function (error) {
                console.error("Failed to fetch Snapchat Pixels", error);
            });
        };

        self.selectPixel = function (pixel) {
            self.selectedPixel = pixel.name;
            self.selectedSnapchatPixel = [{
                id: pixel.id,
                name: pixel.name
            }];
            self.showActions = false;
        };

        self.initComponent = function () {
            if (self.selectedSnapchatPixel && !_.isEmpty(self.selectedSnapchatPixel)) {
                self.selectedSnapchatPixel = JSON.parse(self.selectedSnapchatPixel);
                self.showActions = self.isFormEdit;
                self.editMode = true;
                self.enableViewMode = false;
                self.getSnapchatPixel();
            } else {
                self.selectedSnapchatPixel = '';
                self.showActions = false;
                self.enableViewMode = false;
                self.getSnapchatPixel();
            }
            if ( self.selectedSnapchatPixel !== '') {
                self.selectedPixel = self.selectedSnapchatPixel[0].name;
            }
            self.getSnapchatPixel();
        };
        self.initComponent();
    }
});